import { useTranslation } from "react-i18next";

import menuArrow from "../../../../../assets/img/svg/sidebar/menu-arrow.svg";
import { useAppSelector } from "../../../../../hook/useAppSelector";

interface Props {
  isOpen: boolean;
  title: string;
  icon: string;
}

const Title: React.FC<Props> = ({ isOpen, title, icon }) => {
  const isSidebarMinimized = useAppSelector(
    (state) => state.configSlice.isSidebarMinimized
  );
  const { t } = useTranslation();

  return (
    <span>
      <img src={icon} alt="icon"></img>
      <p className="title">{t(`${title}`)}</p>
      {!isSidebarMinimized && (
        <img
          className={`arrow_icon ${isOpen ? "rotated" : ""}`}
          src={menuArrow}
          alt="menu_arrow"
        ></img>
      )}
    </span>
  );
};

export default Title;
